import {styled, CSSObject, css} from "@core-ui/react-stitch";
import {DrawerProps, DrawerSlidePosition} from "../types";

type StyledDialogProps = Required<Pick<DrawerProps, "position">> &
  Pick<DrawerProps, "hasRoundedCorners">;

const borderRadiusStyles: {[key in DrawerSlidePosition]: CSSObject} = {
  [DrawerSlidePosition.left]: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  [DrawerSlidePosition.right]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  [DrawerSlidePosition.top]: {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
  },
  [DrawerSlidePosition.bottom]: {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
  },
};

export const Dialog = styled.div<StyledDialogProps>`
  background-color: #fff;

  ${({hasRoundedCorners, position, theme}) =>
    hasRoundedCorners &&
    css`
      border-radius: ${theme.borderRadius.modal};
      ${borderRadiusStyles[position]};
    `}

  ${({theme}) => theme.utilities.dropShadow};
  &:focus {
    outline: none;
  }
`;
